const chatTranslationsAR = {
  messagingCenterTitle: 'المراسلات',
  messagingCenter: 'المراسلات',
  systemAdminName: 'مدير النظام',
  chatInputPlaceholder: 'أدخل الرساله هنا',
  sendButtonTooltip: 'إرسال',
  searchInputPlaceholder: 'بحث',
  totalMessagesPostfix: 'رساله',
  noMessages: 'لا توجد رسائل',
};

export default chatTranslationsAR;
